{
  "(optional)": "(اختياري)",
  "(required)": "(مطلوب)"
}
